(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["party-popper-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sliderSelector = '[data-party-popper-slider]';
    const colors = ['#006600', '#00853f', '#ffffff', '#e8f5e9'];
    const randomBetween = (minimum, maximum) => minimum + Math.random() * (maximum - minimum);

    const initializeSlides = (slider) => {
      const slides = Array.from(slider.querySelectorAll('[data-party-popper-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-party-popper-dot]'));
      const previousButton = slider.querySelector('[data-party-popper-previous]');
      const nextButton = slider.querySelector('[data-party-popper-next]');
      const playToggle = slider.querySelector('[data-party-popper-play-toggle]');
      const viewport = slider.querySelector('.party-popper-slider__viewport');
      const autoplay = slider.dataset.autoplay === 'true';
      const interval = Math.max(2000, Number(slider.dataset.interval) || 4000);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let currentIndex = 0;
      let timer = null;
      let userPaused = false;
      let interactionPaused = false;
      let isVisible = true;
      let pointerStartX = null;
      let visibilityObserver;

      if (slides.length < 2) return () => {};

      const updatePlayToggle = () => {
        if (!playToggle) return;
        const icon = playToggle.querySelector('[data-party-popper-play-icon]');
        playToggle.setAttribute('aria-pressed', String(userPaused));
        playToggle.setAttribute('aria-label', userPaused ? 'Play image rotation' : 'Pause image rotation');
        if (icon) icon.innerHTML = userPaused ? '&#9654;' : '&#10074;&#10074;';
      };

      const clearTimer = () => {
        window.clearTimeout(timer);
        timer = null;
      };

      const scheduleNext = () => {
        clearTimer();
        if (!autoplay || reducedMotion || userPaused || interactionPaused || !isVisible) return;
        timer = window.setTimeout(() => {
          showSlide(currentIndex + 1);
          scheduleNext();
        }, interval);
      };

      const showSlide = (requestedIndex, restartTimer = false) => {
        const nextIndex = (requestedIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const active = index === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a, button, input, select, textarea').forEach((control) => {
            if (active) {
              control.removeAttribute('tabindex');
            } else {
              control.setAttribute('tabindex', '-1');
            }
          });
        });

        dots.forEach((dot, index) => {
          const active = index === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        currentIndex = nextIndex;
        if (restartTimer) scheduleNext();
      };

      previousButton?.addEventListener('click', () => showSlide(currentIndex - 1, true));
      nextButton?.addEventListener('click', () => showSlide(currentIndex + 1, true));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => showSlide(Number(dot.dataset.partyPopperDot), true));
      });

      playToggle?.addEventListener('click', () => {
        userPaused = !userPaused;
        updatePlayToggle();
        scheduleNext();
      });

      viewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showSlide(currentIndex - 1, true);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showSlide(currentIndex + 1, true);
        }
      });

      viewport?.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
      });

      viewport?.addEventListener('pointerup', (event) => {
        if (pointerStartX === null) return;
        const distance = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(distance) < 45) return;
        showSlide(currentIndex + (distance < 0 ? 1 : -1), true);
      });

      slider.addEventListener('mouseenter', () => {
        interactionPaused = true;
        clearTimer();
      });

      slider.addEventListener('mouseleave', () => {
        interactionPaused = false;
        scheduleNext();
      });

      slider.addEventListener('focusin', () => {
        interactionPaused = true;
        clearTimer();
      });

      slider.addEventListener('focusout', (event) => {
        if (slider.contains(event.relatedTarget)) return;
        interactionPaused = false;
        scheduleNext();
      });

      const onVisibilityChange = () => {
        if (document.hidden) clearTimer();
        else scheduleNext();
      };
      document.addEventListener('visibilitychange', onVisibilityChange);

      visibilityObserver = new IntersectionObserver((entries) => {
        isVisible = entries.some((entry) => entry.isIntersecting);
        scheduleNext();
      }, { threshold: 0.15 });
      visibilityObserver.observe(slider);

      updatePlayToggle();
      scheduleNext();

      return () => {
        clearTimer();
        visibilityObserver?.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
      };
    };

    const createParticle = (origin, options) => {
      const angle = (-options.angle + randomBetween(options.spread * -0.5, options.spread * 0.5)) * Math.PI / 180;

      return {
        x: origin.x,
        y: origin.y,
        angle,
        velocity: options.startVelocity * randomBetween(0.5, 1.5),
        decay: randomBetween(0.895, 0.91),
        gravity: options.gravity,
        drift: options.drift,
        size: randomBetween(5.2, 8.6) * options.scalar,
        color: colors[Math.floor(Math.random() * colors.length)],
        circle: Math.random() < 0.5,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: randomBetween(-0.08, 0.08),
        tiltAngle: Math.random() * Math.PI * 2,
        tiltSpeed: randomBetween(0.07, 0.12),
        wobble: Math.random() * 10,
        tick: 0,
        totalTicks: options.ticks
      };
    };

    const initializeEffect = (slider) => {
      const canvas = slider.querySelector('.party-popper-slider__canvas');
      if (!canvas || slider.dataset.effectEnabled !== 'true') return () => {};
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return () => {};

      const context = canvas.getContext('2d');
      const requestedCount = Math.max(400, Number(slider.dataset.particleCount) || 1000);
      const emissionDuration = 2000;
      let particles = [];
      let animationFrame;
      let observer;
      let started = false;
      let previousTime = 0;
      let startTime = 0;
      let spawnedCount = 0;
      let emissionAccumulator = 0;
      let viewportWidth = window.innerWidth;
      let viewportHeight = window.innerHeight;

      const resizeCanvas = () => {
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        viewportWidth = window.innerWidth;
        viewportHeight = window.innerHeight;
        canvas.width = Math.round(viewportWidth * pixelRatio);
        canvas.height = Math.round(viewportHeight * pixelRatio);
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      };

      const getOrigins = () => {
        const isMobile = viewportWidth < 750;
        const sideY = viewportHeight * (isMobile ? 0.15 : 0.5);
        return {
          left: { x: 0, y: sideY },
          right: { x: viewportWidth, y: sideY },
          top: { x: Math.random() * viewportWidth, y: viewportHeight * -0.05 }
        };
      };

      const spawnParticle = () => {
        const isMobile = viewportWidth < 750;
        const origins = getOrigins();
        let origin;
        let options;

        if (isMobile) {
          const cycle = spawnedCount % 14;
          if (cycle < 5) {
            origin = origins.left;
            options = { angle: 65, spread: 75, startVelocity: 42, scalar: 0.82, gravity: 0.9, drift: 0.15, ticks: 220 };
          } else if (cycle < 10) {
            origin = origins.right;
            options = { angle: 115, spread: 75, startVelocity: 42, scalar: 0.82, gravity: 0.9, drift: -0.15, ticks: 220 };
          } else {
            origin = origins.top;
            options = { angle: 90, spread: 100, startVelocity: 20, scalar: 0.75, gravity: 0.75, drift: randomBetween(-0.2, 0.2), ticks: 260 };
          }
        } else if (spawnedCount % 8 < 4) {
          origin = origins.left;
          options = { angle: 60, spread: 65, startVelocity: 55, scalar: 1, gravity: 1, drift: 0.2, ticks: 250 };
        } else {
          origin = origins.right;
          options = { angle: 120, spread: 65, startVelocity: 55, scalar: 1, gravity: 1, drift: -0.2, ticks: 250 };
        }

        particles.push(createParticle(origin, options));
        spawnedCount += 1;
      };

      const drawParticle = (particle) => {
        const opacity = Math.max(0, 1 - particle.tick / particle.totalTicks);
        const perspective = Math.max(0.12, Math.abs(Math.cos(particle.tiltAngle)));
        context.save();
        context.translate(particle.x, particle.y);
        context.rotate(particle.rotation);
        context.globalAlpha = opacity;
        context.fillStyle = particle.color;

        if (particle.circle) {
          context.beginPath();
          context.ellipse(0, 0, particle.size * 0.52, particle.size * 0.52 * perspective, 0, 0, Math.PI * 2);
          context.fill();
        } else {
          context.scale(1, perspective);
          context.fillRect(particle.size * -0.5, particle.size * -0.5, particle.size, particle.size);
        }
        context.restore();
      };

      const animate = (time) => {
        if (!startTime) {
          startTime = time;
          previousTime = time;
        }

        const elapsed = time - startTime;
        const deltaTime = Math.max(0, time - previousTime);
        const frameScale = Math.min(deltaTime / 16.667, 2.4);
        previousTime = time;

        if (elapsed < emissionDuration && spawnedCount < requestedCount) {
          emissionAccumulator += deltaTime * requestedCount / emissionDuration;
          const emitCount = Math.min(requestedCount - spawnedCount, Math.floor(emissionAccumulator));
          for (let index = 0; index < emitCount; index += 1) spawnParticle();
          emissionAccumulator -= emitCount;
        }

        context.clearRect(0, 0, viewportWidth, viewportHeight);
        particles.forEach((particle) => {
          particle.wobble += 0.1 * frameScale;
          particle.velocity *= Math.pow(particle.decay, frameScale);
          particle.x += (Math.cos(particle.angle) * particle.velocity + particle.drift) * frameScale;
          particle.y += (Math.sin(particle.angle) * particle.velocity + particle.gravity * 3 + Math.sin(particle.wobble) * 0.5) * frameScale;
          particle.rotation += particle.rotationSpeed * frameScale;
          particle.tiltAngle += particle.tiltSpeed * frameScale;
          particle.tick += frameScale;
          drawParticle(particle);
        });

        particles = particles.filter((particle) => (
          particle.tick < particle.totalTicks
          && particle.y < viewportHeight + 120
          && particle.x > -160
          && particle.x < viewportWidth + 160
        ));

        if (elapsed < emissionDuration || particles.length > 0) {
          animationFrame = window.requestAnimationFrame(animate);
        } else {
          context.clearRect(0, 0, viewportWidth, viewportHeight);
          canvas.classList.remove('is-active');
        }
      };

      const startEffect = () => {
        if (started) return;
        started = true;
        resizeCanvas();
        const initialCount = Math.min(requestedCount, viewportWidth < 750 ? 14 : 8);
        for (let index = 0; index < initialCount; index += 1) spawnParticle();
        canvas.classList.add('is-active');
        animationFrame = window.requestAnimationFrame(animate);
      };

      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          startEffect();
          observer.disconnect();
        }
      }, { threshold: 0.18 });

      observer.observe(slider);
      window.addEventListener('resize', resizeCanvas, { passive: true });

      return () => {
        observer?.disconnect();
        window.cancelAnimationFrame(animationFrame);
        window.removeEventListener('resize', resizeCanvas);
      };
    };

    const initializeSlider = (slider) => {
      if (!slider || slider.dataset.partyPopperSliderReady === 'true') return;
      slider.dataset.partyPopperSliderReady = 'true';
      const cleanupSlides = initializeSlides(slider);
      const cleanupEffect = initializeEffect(slider);
      slider.partyPopperSliderCleanup = () => {
        cleanupSlides();
        cleanupEffect();
      };
    };

    const initializeAll = (root = document) => {
      if (root.matches?.(sliderSelector)) initializeSlider(root);
      root.querySelectorAll?.(sliderSelector).forEach(initializeSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const slider = event.target.matches?.(sliderSelector)
        ? event.target
        : event.target.querySelector?.(sliderSelector);
      slider?.partyPopperSliderCleanup?.();
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-party-popper-slide]');
      if (!slide) return;
      const slider = slide.closest(sliderSelector);
      const dot = slider?.querySelector(`[data-party-popper-dot="${slide.dataset.slideIndex}"]`);
      dot?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["party-popper-image-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bannerSelector = '[data-party-popper-banner]';
    const colors = ['#006600', '#00853f', '#ffffff', '#e8f5e9'];

    const randomBetween = (minimum, maximum) => minimum + Math.random() * (maximum - minimum);

    const createParticle = (origin, options) => {
      const angle = (-options.angle + randomBetween(options.spread * -0.5, options.spread * 0.5)) * Math.PI / 180;

      return {
        x: origin.x,
        y: origin.y,
        angle,
        velocity: options.startVelocity * randomBetween(0.5, 1.5),
        decay: randomBetween(0.895, 0.91),
        gravity: options.gravity,
        drift: options.drift,
        size: randomBetween(5.2, 8.6) * options.scalar,
        color: colors[Math.floor(Math.random() * colors.length)],
        circle: Math.random() < 0.5,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: randomBetween(-0.08, 0.08),
        tiltAngle: Math.random() * Math.PI * 2,
        tiltSpeed: randomBetween(0.07, 0.12),
        wobble: Math.random() * 10,
        tick: 0,
        totalTicks: options.ticks
      };
    };

    const initializeBanner = (banner) => {
      if (!banner || banner.dataset.partyPopperReady === 'true') return;
      banner.dataset.partyPopperReady = 'true';

      const canvas = banner.querySelector('.party-popper-banner__canvas');
      if (!canvas || banner.dataset.effectEnabled !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const context = canvas.getContext('2d');
      const requestedCount = Math.max(400, Number(banner.dataset.particleCount) || 1000);
      const emissionDuration = 2000;
      let particles = [];
      let animationFrame;
      let observer;
      let started = false;
      let previousTime = 0;
      let startTime = 0;
      let spawnedCount = 0;
      let emissionAccumulator = 0;
      let viewportWidth = window.innerWidth;
      let viewportHeight = window.innerHeight;

      const resizeCanvas = () => {
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        viewportWidth = window.innerWidth;
        viewportHeight = window.innerHeight;
        canvas.width = Math.round(viewportWidth * pixelRatio);
        canvas.height = Math.round(viewportHeight * pixelRatio);
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      };

      const getOrigins = () => {
        const isMobile = viewportWidth < 750;
        const sideY = viewportHeight * (isMobile ? 0.15 : 0.5);

        return {
          left: { x: 0, y: sideY },
          right: { x: viewportWidth, y: sideY },
          top: { x: Math.random() * viewportWidth, y: viewportHeight * -0.05 }
        };
      };

      const spawnParticle = () => {
        const isMobile = viewportWidth < 750;
        const origins = getOrigins();
        let origin;
        let options;

        if (isMobile) {
          const cycle = spawnedCount % 14;

          if (cycle < 5) {
            origin = origins.left;
            options = { angle: 65, spread: 75, startVelocity: 42, scalar: 0.82, gravity: 0.9, drift: 0.15, ticks: 220 };
          } else if (cycle < 10) {
            origin = origins.right;
            options = { angle: 115, spread: 75, startVelocity: 42, scalar: 0.82, gravity: 0.9, drift: -0.15, ticks: 220 };
          } else {
            origin = origins.top;
            options = { angle: 90, spread: 100, startVelocity: 20, scalar: 0.75, gravity: 0.75, drift: randomBetween(-0.2, 0.2), ticks: 260 };
          }
        } else if (spawnedCount % 8 < 4) {
          origin = origins.left;
          options = { angle: 60, spread: 65, startVelocity: 55, scalar: 1, gravity: 1, drift: 0.2, ticks: 250 };
        } else {
          origin = origins.right;
          options = { angle: 120, spread: 65, startVelocity: 55, scalar: 1, gravity: 1, drift: -0.2, ticks: 250 };
        }

        particles.push(createParticle(origin, options));
        spawnedCount += 1;
      };

      const drawParticle = (particle) => {
        const opacity = Math.max(0, 1 - particle.tick / particle.totalTicks);
        const perspective = Math.max(0.12, Math.abs(Math.cos(particle.tiltAngle)));

        context.save();
        context.translate(particle.x, particle.y);
        context.rotate(particle.rotation);
        context.globalAlpha = opacity;
        context.fillStyle = particle.color;

        if (particle.circle) {
          context.beginPath();
          context.ellipse(
            0,
            0,
            particle.size * 0.52,
            particle.size * 0.52 * perspective,
            0,
            0,
            Math.PI * 2
          );
          context.fill();
        } else {
          context.scale(1, perspective);
          context.fillRect(
            particle.size * -0.5,
            particle.size * -0.5,
            particle.size,
            particle.size
          );
        }

        context.restore();
      };

      const animate = (time) => {
        if (!startTime) {
          startTime = time;
          previousTime = time;
        }

        const elapsed = time - startTime;
        const deltaTime = Math.max(0, time - previousTime);
        const frameScale = Math.min(deltaTime / 16.667, 2.4);
        previousTime = time;

        if (elapsed < emissionDuration && spawnedCount < requestedCount) {
          emissionAccumulator += deltaTime * requestedCount / emissionDuration;
          const emitCount = Math.min(
            requestedCount - spawnedCount,
            Math.floor(emissionAccumulator)
          );

          for (let index = 0; index < emitCount; index += 1) {
            spawnParticle();
          }

          emissionAccumulator -= emitCount;
        }

        context.clearRect(0, 0, viewportWidth, viewportHeight);

        particles.forEach((particle) => {
          particle.wobble += 0.1 * frameScale;
          particle.velocity *= Math.pow(particle.decay, frameScale);
          particle.x += (Math.cos(particle.angle) * particle.velocity + particle.drift) * frameScale;
          particle.y += (
            Math.sin(particle.angle) * particle.velocity
            + particle.gravity * 3
            + Math.sin(particle.wobble) * 0.5
          ) * frameScale;
          particle.rotation += particle.rotationSpeed * frameScale;
          particle.tiltAngle += particle.tiltSpeed * frameScale;
          particle.tick += frameScale;
          drawParticle(particle);
        });

        particles = particles.filter((particle) => (
          particle.tick < particle.totalTicks
          && particle.y < viewportHeight + 120
          && particle.x > -160
          && particle.x < viewportWidth + 160
        ));

        if (elapsed < emissionDuration || particles.length > 0) {
          animationFrame = window.requestAnimationFrame(animate);
        } else {
          context.clearRect(0, 0, viewportWidth, viewportHeight);
          canvas.classList.remove('is-active');
        }
      };

      const startEffect = () => {
        if (started) return;
        started = true;
        resizeCanvas();
        const initialCount = Math.min(requestedCount, viewportWidth < 750 ? 14 : 8);
        for (let index = 0; index < initialCount; index += 1) {
          spawnParticle();
        }
        canvas.classList.add('is-active');
        animationFrame = window.requestAnimationFrame(animate);
      };

      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          startEffect();
          observer.disconnect();
        }
      }, { threshold: 0.18 });

      observer.observe(banner);
      window.addEventListener('resize', resizeCanvas, { passive: true });

      banner.partyPopperCleanup = () => {
        if (observer) observer.disconnect();
        window.cancelAnimationFrame(animationFrame);
        window.removeEventListener('resize', resizeCanvas);
      };
    };

    const initializeAll = (root = document) => {
      if (root.matches && root.matches(bannerSelector)) initializeBanner(root);
      root.querySelectorAll(bannerSelector).forEach(initializeBanner);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const banner = event.target.matches(bannerSelector) ? event.target : event.target.querySelector(bannerSelector);
      if (banner && banner.partyPopperCleanup) banner.partyPopperCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfume-story-video"] && !Shopify.designMode) return;
  try {
    
  const setupPerfumeStoryVideos = (root = document) => {
    root.querySelectorAll('[data-perfume-story-video]').forEach((section) => {
      if (section.dataset.videoReady === 'true') return;

      const video = section.querySelector('video');
      const toggle = section.querySelector('[data-video-toggle]');
      const playIcon = section.querySelector('[data-video-play]');
      const pauseIcon = section.querySelector('[data-video-pause]');
      const soundToggle = section.querySelector('[data-sound-toggle]');
      const soundOnIcon = section.querySelector('[data-sound-on]');
      const soundOffIcon = section.querySelector('[data-sound-off]');

      if (!video || !toggle || !playIcon || !pauseIcon || !soundToggle || !soundOnIcon || !soundOffIcon) return;

      const setPlayingState = (isPlaying) => {
        playIcon.hidden = isPlaying;
        pauseIcon.hidden = !isPlaying;
        toggle.setAttribute('aria-label', isPlaying ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      };

      const setMutedState = (isMuted) => {
        soundOnIcon.hidden = isMuted;
        soundOffIcon.hidden = !isMuted;
        soundToggle.setAttribute('aria-label', isMuted ? soundToggle.dataset.unmuteLabel : soundToggle.dataset.muteLabel);
        soundToggle.setAttribute('aria-pressed', String(!isMuted));
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.pause();
        setPlayingState(false);
      } else {
        setPlayingState(!video.paused);
      }
      setMutedState(video.muted || video.volume === 0);

      toggle.addEventListener('click', () => {
        if (video.paused) {
          video.play().then(() => setPlayingState(true)).catch(() => setPlayingState(false));
        } else {
          video.pause();
          setPlayingState(false);
        }
      });

      soundToggle.addEventListener('click', () => {
        if (video.muted || video.volume === 0) {
          video.muted = false;
          if (video.volume === 0) video.volume = 1;
        } else {
          video.muted = true;
        }
        setMutedState(video.muted || video.volume === 0);
      });

      video.addEventListener('play', () => setPlayingState(true));
      video.addEventListener('pause', () => setPlayingState(false));
      video.addEventListener('volumechange', () => setMutedState(video.muted || video.volume === 0));
      section.dataset.videoReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupPerfumeStoryVideos(), { once: true });
  } else {
    setupPerfumeStoryVideos();
  }

  document.addEventListener('shopify:section:load', (event) => setupPerfumeStoryVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
